import React, { useEffect, useState } from 'react'
import { Grid, } from '@material-ui/core';
import Controls from "../../../controls/Controls";
import { useForm, Form } from '../../../controls/useForm';
import { request } from '../../../../api/Service'
import { store } from '../../../../redux-store/store';

const initialFValues = {
    id: 0,
    timeSpan: '',
    amount: '',
}

export default function OrderDeliveryForm(props) {
    console.log(store.getState().pickUpStationReducer.allStates)
    const { addOrEdit, recordForEdit } = props
    const [states, setStates] = useState(store.getState().pickUpStationReducer.allStates);
    const [cities, setCities] = useState(store.getState().pickUpStationReducer.allCities);
    const validate = (fieldValues = values) => {
        let temp = { ...errors }
        if ('timeSpan' in fieldValues)
            temp.timeSpan = fieldValues.timeSpan ? "" : "This field is required."
        if ('amount' in fieldValues)
            temp.amount = fieldValues.amount ? "" : "This field is required."
        if ('countryId' in fieldValues)
            temp.countryId = fieldValues.countryId !== "" ? "" : "Select a Country"
        if ('stateId' in fieldValues)
            temp.stateId = fieldValues.stateId !== "" ? "" : "Select a State"
        if ('cityId' in fieldValues)
            temp.cityId = fieldValues.cityId ? "" : "Select a City"
        setErrors({
            ...temp
        })

        if (fieldValues === values)
            return Object.values(temp).every(x => x === "")
    }
    const handleCountrySelectChange = e => {
        const { name, value } = e.target
        setValues({
            ...values,
            [name]: value
        })

        validate({ [name]: value })
        request('get', {}, `api/Admin/get-states-dropdown/${value}`).then(data => {
            console.log(data)
            setStates(data);
        })
    }

    const handleStateInputChange = e => {
        const { name, value } = e.target
        setValues({
            ...values,
            [name]: value
        })

        validate({ [name]: value })
        request('get', {}, `api/Admin/get-cities-dropdown/${value}`).then(data => {
            console.log(data)
            setCities(data)
        })
    }
    const {
        values,
        setValues,
        errors,
        setErrors,
        handleInputChange,
        resetForm
    } = useForm(initialFValues, true, validate);

    const handleSubmit = e => {
        e.preventDefault()
        if (validate()) {
            var result = { ...values, 'companyId': store.getState().persistReducer.companyId }
            addOrEdit(result, resetForm);
        }
    }

    useEffect(() => {
        if (recordForEdit !== null)
            setValues({
                ...recordForEdit
            })
    }, [recordForEdit])

    return (
        <Form onSubmit={handleSubmit}>
            <Grid container>
                <Grid item xs={6}>
                    <Controls.Input
                        name="timeSpan"
                        label="Time Span(In Days)"
                        value={values.timeSpan || ''}
                        onChange={handleInputChange}
                        error={errors.openingTime}
                    />
                    <Controls.Input
                        label="Amount"
                        name="amount"
                        value={values.amount || ''}
                        onChange={handleInputChange}
                        error={errors.closingTime}
                    />
                    <Controls.Select
                        name="countryId"
                        label="Countries"
                        value={values.countryId || ''}
                        onChange={handleCountrySelectChange}
                        options={props.countries}
                        error={errors.countryId}
                    />
                </Grid>
                <Grid item xs={6}>

                    <Controls.Select
                        name="stateId"
                        label="State"
                        value={values.stateId || ''}
                        onChange={handleStateInputChange}
                        options={states}
                        error={errors.stateId}
                    />

                    <Controls.Select
                        name="cityId"
                        label="City"
                        value={values.cityId || ''}
                        onChange={handleInputChange}
                        options={cities}
                        error={errors.cityId}
                    />
                    <div>
                        <Controls.Button
                            type="submit"
                            text="Submit" />
                    </div>
                </Grid>
            </Grid>
        </Form>
    )
}
